import { portalHomeBeforeEnter } from "./portalHomeAccess";

const portalBonusCampaignPage = () =>
  import(
    /* webpackChunkName: "portal-bonus-campaign" */ "@/views/PortalBonusCampaignPage.vue"
  );

const BONUS_CAMPAIGN_ROUTES = [
  { path: "/bonus/uhrd", name: "bonusUhrd", campaignSlug: "uhrd" },
  { path: "/bonus/awans", name: "bonusAwans", campaignSlug: "awans" },
  { path: "/bonus/goals", name: "bonusGoals", campaignSlug: "goals" },
];

export default [
  ...BONUS_CAMPAIGN_ROUTES.map(({ path, name, campaignSlug }) => ({
    path,
    name,
    beforeEnter: portalHomeBeforeEnter,
    meta: {
      authRequired: true,
    },
    props: { campaignSlug },
    component: portalBonusCampaignPage,
  })),
  { path: "/bonus-uhrd", redirect: "/bonus/uhrd" },
];
